<div #overlay class="overlay">
    <div class="content center-content">
        <div class="content-container" data-cy="vessel-folder-req-approval-requester-modal">
            <div class="padding-container">
                <div class="column-flex">
                    <div class="dialog-title" data-cy="vessel-folder-req-approval-requester-modal-header">
                        {{ 'approval.request.dialog.title' | translate: { version: data.vessel.projectVersion } }}
                    </div>
                    <div class="step-container">
                        <div class="step-container-header">
                            <div
                                class="step-text"
                                data-cy="vessel-folder-req-approval-requester-modal-step-1-of-3-text">
                                {{ 'approval.request.dialog.steps' | translate: { step: 1 } }}
                            </div>
                            <div
                                class="form-label"
                                data-cy="vessel-folder-req-approval-requester-modal-step-1-of-3-label">
                                {{ 'approval.request.dialog.subtitle' | translate }}
                            </div>
                        </div>
                        <form class="input-form" *ngIf="approversList">
                            <app-input-select-with-error
                                [initialValue]="selectedApprover"
                                [legend]="'approval.request.dialog.form.legend'"
                                [placeholder]="'approval.request.dialog.form.placeholder'"
                                [optionsArray]="approversList"
                                [displayKey]="'name'"
                                [maxLength]="50"
                                (onInputUpdated)="selectedApprover = $event"></app-input-select-with-error>
                        </form>
                        <div class="approver-container" *ngIf="selectedApprover?.email">
                            <div
                                style="font-weight: bold"
                                data-cy="vessel-folder-req-approval-requester-modal-approver-name">
                                {{ selectedApprover.name }}
                            </div>
                            <div data-cy="vessel-folder-req-approval-requester-modal-approver-email">
                                {{ selectedApprover.email }}
                            </div>
                        </div>
                    </div>

                    <div class="step-container">
                        <div class="step-container-header">
                            <div
                                class="step-text"
                                data-cy="vessel-folder-req-approval-requester-modal-step-2-of-3-text">
                                {{ 'approval.request.dialog.steps' | translate: { step: 2 } }}
                            </div>
                            <div
                                class="form-label"
                                data-cy="vessel-folder-req-approval-requester-modal-step-2-of-3-label">
                                {{ 'approval.request.dialog.name.title' | translate }}
                            </div>
                        </div>
                        <app-version-name-page
                            [inApprovalPage]="true"
                            [referenceVersion]="data.vessel.projectVersion"
                            [versions]="versions"
                            (onVersionNameChange)="data.vessel.projectVersion = $event"></app-version-name-page>
                    </div>

                    <div class="step-container">
                        <div class="step-container-header">
                            <div
                                class="step-text"
                                data-cy="vessel-folder-req-approval-requester-modal-step-3-of-3-text">
                                {{ 'approval.request.dialog.steps' | translate: { step: 3 } }}
                            </div>
                            <div
                                class="form-label"
                                data-cy="vessel-folder-req-approval-requester-modal-step-3-of-3-label">
                                {{ 'approval.request.dialog.reason.title' | translate }}
                            </div>
                        </div>
                        <div class="reasons-checkbox-container">
                            <mat-checkbox
                                class="example-margin"
                                data-cy="vessel-folder-req-approval-requester-modal-checkbox-customer-req"
                                [(ngModel)]="customerRequestCheckbox">
                                {{ 'approval.request.dialog.reason.checkbox.customer' | translate }}
                            </mat-checkbox>
                            <mat-checkbox
                                class="example-margin"
                                data-cy="vessel-folder-req-approval-requester-modal-checkbox-misconfiguration"
                                [(ngModel)]="misconfigurationCheckbox">
                                {{ 'approval.request.dialog.reason.checkbox.misconfiguration' | translate }}
                            </mat-checkbox>
                            <mat-checkbox
                                class="example-margin"
                                data-cy="vessel-folder-req-approval-requester-modal-checkbox-internal-req"
                                [(ngModel)]="internalRequestCheckbox">
                                {{ 'approval.request.dialog.reason.checkbox.internal' | translate }}
                            </mat-checkbox>
                            <mat-checkbox
                                class="example-margin"
                                data-cy="vessel-folder-req-approval-requester-modal-checkbox-other"
                                [(ngModel)]="otherCheckbox">
                                {{ 'approval.request.dialog.reason.checkbox.other' | translate }}
                            </mat-checkbox>
                        </div>
                        <app-textarea-with-error
                            *ngIf="otherCheckbox"
                            class="input-form"
                            [inputValue]="otherReason"
                            [legend]="'approval.request.dialog.reason.form.other'"
                            [propertyName]="'other'"
                            [validatorFunction]="validatorFunction()"
                            (onInputUpdated)="otherReason = $event"
                            [maxLength]="OTHER_REASON_MAX_LENGTH"
                            [rows]="9"></app-textarea-with-error>
                        <app-textarea-with-error
                            class="input-form"
                            [inputValue]="comment"
                            [legend]="'approval.request.dialog.reason.form.comment'"
                            [propertyName]="'comment'"
                            [validatorFunction]="validatorFunction()"
                            (onInputUpdated)="comment = $event"
                            [maxLength]="COMMENT_MAX_LENGTH"
                            [rows]="9"></app-textarea-with-error>
                    </div>
                </div>

                <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
            </div>

            <div class="buttons-container">
                <div
                    class="cancel button"
                    data-cy="vessel-folder-req-approval-requester-modal-cancel-btn"
                    (click)="clearForm()">
                    {{ 'approval.request.dialog.cancel' | translate }}
                </div>
                <div
                    class="create button"
                    data-cy="vessel-folder-req-approval-requester-modal-submit-btn"
                    [ngClass]="{ button_disabled: isButtonDisabled() }"
                    (click)="requestApproval()">
                    {{ 'approval.request.dialog.submit' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
